/* EU withdrawal form — 3-step flow (port of original `iG`). */
(function () {
  if (customElements.get('withdrawal-form')) return;
  var STORE_KEY = 'brogi-withdrawal-draft';
  var DOT_ON = ['bg-navy', 'text-primary-foreground', 'border-navy'];
  var DOT_OFF = ['bg-background', 'text-muted-foreground', 'border-border'];

  function toast(msg, type) { if (window.BrogiToast && msg) BrogiToast.show(msg, { type: type || 'success' }); }
  function ss(k, v) {
    try {
      if (v === undefined) return JSON.parse(sessionStorage.getItem(k) || 'null');
      if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, JSON.stringify(v));
    } catch (e) { return null; }
  }

  class WithdrawalForm extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.form.noValidate = true;
      this.fields = {};
      this.querySelectorAll('[data-field]').forEach(function (el) { self.fields[el.getAttribute('data-field')] = el; });
      this.confirmBtn = this.querySelector('[data-confirm]');
      this.nextBtn = this.querySelector('[data-step-next]');
      this.submitBtn = this.querySelector('[data-step-submit]');
      this.confirmed = false;
      this.busy = false;

      var steps = this.querySelector('[data-steps]');
      var posted = steps && steps.getAttribute('data-posted') === 'true';
      var errors = steps && steps.getAttribute('data-errors');
      var draft = ss(STORE_KEY);

      if (posted) {
        this.showSuccess(draft || {});
        ss(STORE_KEY, null);
        return;
      }
      if (draft) { this.fill(draft); }
      if (errors) toast(errors, 'error');

      this.form.addEventListener('input', function () { self.validate(); });
      this.form.addEventListener('change', function () { self.validate(); });
      this.nextBtn.addEventListener('click', function () { if (self.step1Valid()) self.go(2); });
      this.querySelector('[data-step-back]').addEventListener('click', function () { self.go(1); });
      this.confirmBtn.addEventListener('click', function (e) {
        e.preventDefault();
        self.setConfirmed(!self.confirmed);
      });
      this.form.addEventListener('submit', function (e) { self.onSubmit(e); });
      this.go(1);
    }

    values() {
      var v = {};
      for (var k in this.fields) v[k] = this.fields[k].value;
      v.confirm = this.confirmed;
      return v;
    }

    fill(v) {
      for (var k in this.fields) if (v[k] != null) this.fields[k].value = v[k];
    }

    step1Valid() {
      var v = this.values();
      return !!(v.name.trim() && v.email.trim() && v.orderNumber.trim() && v.orderDate.trim());
    }

    validate() {
      this.nextBtn.disabled = !this.step1Valid();
      this.submitBtn.disabled = !this.confirmed || this.busy;
    }

    setConfirmed(on) {
      this.confirmed = on;
      this.confirmBtn.setAttribute('aria-checked', on ? 'true' : 'false');
      this.confirmBtn.setAttribute('data-state', on ? 'checked' : 'unchecked');
      this.querySelector('[data-confirm-indicator]').hidden = !on;
      this.validate();
    }

    go(step) {
      this.step = step;
      this.querySelectorAll('[data-step-panel]').forEach(function (p) {
        p.hidden = Number(p.getAttribute('data-step-panel')) !== step;
      });
      this.querySelectorAll('[data-step-dot]').forEach(function (d) {
        var on = step >= Number(d.getAttribute('data-step-dot'));
        DOT_ON.forEach(function (c) { d.classList.toggle(c, on); });
        DOT_OFF.forEach(function (c) { d.classList.toggle(c, !on); });
      });
      this.querySelectorAll('[data-step-line]').forEach(function (l) {
        var on = step > Number(l.getAttribute('data-step-line'));
        l.classList.toggle('bg-navy', on);
        l.classList.toggle('bg-border', !on);
      });
      if (step === 2) this.renderSummary();
      this.validate();
    }

    statement(v) {
      var d = this.dataset;
      var received = v.receivedDate ? (d.received || '').replace('[received_date]', v.receivedDate) : '';
      return (d.statement || '')
        .replace('[order_date]', v.orderDate || d.placeholderDate || '')
        .replace('[received]', received);
    }

    renderSummary() {
      var v = this.values();
      this.querySelectorAll('[data-summary]').forEach(function (el) {
        el.textContent = v[el.getAttribute('data-summary')] || '';
      });
      this.querySelectorAll('[data-summary-received]').forEach(function (el) { el.hidden = !v.receivedDate; });
      this.querySelector('[data-statement-text]').textContent = this.statement(v);
    }

    onSubmit(e) {
      var self = this;
      if (!this.confirmed) {
        e.preventDefault();
        toast(this.dataset.msgConfirm, 'error');
        return;
      }
      if (this.busy) { e.preventDefault(); return; }
      var v = this.values();
      this.setBusy(true);

      if (this.dataset.mode === 'endpoint') {
        e.preventDefault();
        var key = this.dataset.key || '';
        var headers = { 'Content-Type': 'application/json' };
        if (key) { headers.Authorization = 'Bearer ' + key; headers.apikey = key; }
        fetch(this.dataset.endpoint, { method: 'POST', headers: headers, body: JSON.stringify(v) })
          .then(function (r) { return r.json().catch(function () { return {}; }); })
          .then(function (data) {
            if (!data || !data.success) throw new Error((data && data.error) || self.dataset.msgError);
            self.showSuccess(v);
          })
          .catch(function (err) { toast((err && err.message) || self.dataset.msgError, 'error'); })
          .then(function () { self.setBusy(false); });
        return;
      }

      // Shopify contact form: native POST (page reloads, step 3 via form.posted_successfully?).
      var lines = [
        this.statement(v), '',
        'Name: ' + v.name, 'Email: ' + v.email, 'Order number: ' + v.orderNumber, 'Order date: ' + v.orderDate,
        'Date received: ' + (v.receivedDate || '-'), 'Postal address: ' + (v.address || '-'), 'Reason: ' + (v.reason || '-')
      ];
      this.querySelector('[data-field-body]').value = lines.join('\n');
      this.querySelector('[data-field-confirm-value]').value = 'Yes — confirmed by customer on ' + new Date().toISOString();
      ss(STORE_KEY, v);
    }

    setBusy(b) {
      this.busy = b;
      this.submitBtn.textContent = b ? this.dataset.submittingLabel : this.dataset.submitLabel;
      this.validate();
    }

    showSuccess(v) {
      var tpl = this.dataset.success || '';
      var p = this.querySelector('[data-success-text]');
      if (p) {
        p.textContent = '';
        var parts = tpl.replace('[name]', v.name || '').split('[email]');
        parts.forEach(function (part, i) {
          if (i > 0) {
            var span = document.createElement('span');
            span.className = 'text-foreground';
            span.textContent = v.email || '';
            p.appendChild(span);
          }
          p.appendChild(document.createTextNode(part));
        });
      }
      this.go(3);
    }
  }
  customElements.define('withdrawal-form', WithdrawalForm);
})();
